import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MLineMHSPage from 'src/pages/mline/mhs';
import PostProcessorMaintenancePage from 'src/pages/post-processor/[uuid]/maintenance';
import PostProcessorQueuePage from 'src/pages/post-processor/queue';
import PrivateRoute from 'src/routes/PrivateRoute';

import NotFoundPage from '../pages/not-found';

const PostProcessorRoutes = () => (
  <Routes>
    <Route index path='/:uuid' element={<PrivateRoute Component={MLineMHSPage} />} />
    <Route path='/:uuid/queue' element={<PrivateRoute Component={PostProcessorQueuePage} />} />
    <Route
      path='/:uuid/maintenance'
      element={<PrivateRoute Component={PostProcessorMaintenancePage} />}
    />
    <Route path='*' element={<NotFoundPage />} />
  </Routes>
);

export default PostProcessorRoutes;
